// eslint-disable-next-line no-restricted-imports
import { BigNumber } from '@ethersproject/bignumber'
import { Currency, CurrencyAmount } from '@uniswap/sdk-core'
import { UnstakeCallbackState, useUnstake as useLibSwapCallBack } from 'lib/hooks/swap/useUnstake'
import { ReactNode, useMemo } from 'react'

import { useTransactionAdder } from '../state/transactions/hooks'
import { TransactionType } from '../state/transactions/types'

// returns a function that will execute a borrow, if the parameters are all valid
export function useUnstakeCallback(stakeToConfirm: CurrencyAmount<Currency> | undefined): {
  state: UnstakeCallbackState
  callback: (() => Promise<string>) | null
  error: ReactNode | null
} {
  const addTransaction = useTransactionAdder()

  const {
    state,
    callback: libCallback,
    error,
  } = useLibSwapCallBack({
    unstakeAmount: stakeToConfirm ? BigNumber.from(stakeToConfirm.numerator.toString()) : stakeToConfirm,
  })

  const callback = useMemo(() => {
    if (!libCallback || !stakeToConfirm) {
      return null
    }

    return () =>
      libCallback().then((response) => {
        addTransaction(response, {
          type: TransactionType.UNSTAKE,
          unstakeAmount: stakeToConfirm.numerator.toString(),
        })
        return response.hash
      })
  }, [libCallback, addTransaction, stakeToConfirm])

  return {
    state,
    callback,
    error,
  }
}
